import React from "react";
import context from "./context";

export * from "../../di-context/hooks";

export const useServices = (...names) => {
	const { container } = React.useContext(context);

	return React.useMemo(
		() => names.map(name => container[name]),
		names, //
	);
};
